/* global axios */
import ApiClient from '../ApiClient';

class CaptainAssistant extends ApiClient {
  constructor() {
    super('captain/assistants', { accountScoped: true });
  }

  // 29-ago — `skipForbiddenToast` OPCIONAL, para las llamadas de FONDO.
  //
  // El Copilot despacha este `get` en `onMounted` (CopilotContainer.vue) para saber qué asistente
  // usar — UNA VEZ POR MONTAJE, sin que la persona pida nada. Para un rol con `copilot_access`
  // pero sin acceso a los asistentes de Captain eso es un 403 — correcto y no accionable por él —,
  // y el interceptor global de APIHelper.js muestra el toast «No tienes los permisos necesarios»
  // en CUALQUIER 403 antes de que el `catch` del store se lo trague. Mismo caso EXACTO que
  // `integrations.js#get` y `contacts.js#getContactableInboxes`.
  //
  // El flag viaja SOLO desde el Copilot. Las pantallas de Ajustes (assistants, documents,
  // responses) llaman a este `get` sin el flag, así que ahí un 403 sí avisa — aunque no debería
  // pasar, porque a esas rutas sólo llega quien tiene acceso. El error sigue llegando al `catch`.
  get({ page = 1, searchKey, skipForbiddenToast = false } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        searchKey,
      },
      skipForbiddenToast,
    });
  }

  playground({ assistantId, messageContent, messageHistory }) {
    return axios.post(`${this.url}/${assistantId}/playground`, {
      message_content: messageContent,
      message_history: messageHistory,
    });
  }
}

export default new CaptainAssistant();
